import React from "react";
import { Container, Box, Typography, Button, Grid, Paper } from "@mui/material";
import { theme } from "./utils/theme";
// import products from "./utils/ProductsMockData.json";

function ProductCard({ products, onBack }) {
  return (
    <Box sx={{pt:1}}>
      <Grid container spacing={2}alignItems="stretch">
        {products.map((product) => (
          <Grid
            item
            size={{ xs: 12, sm:6, md: 6, lg: 4 }}
            sx={{
              display: "flex",
              flexGrow: 1,
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            <Container sx={{ py: 2 }}>
              <Paper
                elevation={6}
                sx={{
                  p: { xs: 2, md: 4 },
                  borderRadius: "20px",
                  background: theme.palette.background.paper,
                  backdropFilter: "blur(10px)",
                }}
              >
                <Grid container spacing={4} direction="column">
                  <Grid item>
                    <Box
                      sx={{
                        height: { lg: 700 },
                        borderRadius: "15px",
                      }}
                    >
                      <img
                        key={0}
                        src={require(process.env.PUBLIC_URL +
                          product.images[0])}
                        alt={product.name}
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "fill",
                        }}
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src =
                            "https://placehold.co/600x400/333/FFF?text=Image+Error";
                        }}
                      />
                    </Box>
                  </Grid>
                  <Grid
                    item
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                    }}
                  >
                    <Typography
                      variant="h4"
                      component="h1"
                      gutterBottom
                      fontWeight="bold"
                    >
                      {product.name}
                    </Typography>
                    <Typography variant="body1" paragraph color="#6b686d">
                      {product.description}
                    </Typography>
                    <Box sx={{ mt: 4, display:'flex', justifyContent:'center', display: "flex", gap: 2 }}>
                      <Button variant="contained" size="large" sx={{background:"#f2f2f2"}}>
                        View Details
                      </Button>
                    </Box>
                  </Grid>
                </Grid>
              </Paper>
            </Container>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}

export default ProductCard;
